const actionTypes = {
    START_MENU_LOAD: "START_MENU_LOAD",
    CREATE_MENU: "CREATE_MENU",
    TOGGLE_MENU: "TOGGLE_MENU",
    ACTIVE_MENU: "ACTIVE_MENU",
    KEEP_OPENED_MENU: "KEEP_OPENED_MENU",
};

export const createMenu = (items) => {
    return {type: actionTypes.CREATE_MENU, items};
};
export const toggleMenu = (toggleItem, toggle) => {
    return {type: actionTypes.TOGGLE_MENU, toggleItem, toggle};
};
export const activeMenu = (content, active) => {
    return {type: actionTypes.ACTIVE_MENU, content, active};
};
export const keepOpenedMenu = (keepOpened) => {
    return {type: actionTypes.KEEP_OPENED_MENU, keepOpened};
};

export default actionTypes;